export default {"src":"/_next/static/media/logo4.ad2d6e98.svg","height":74,"width":250};